import { useState, useEffect } from "react";
import { T, TF } from "react-translator-component";
import {
  Box, Paper,
  Table, TableBody, TableCell, TableContainer, TableHead, TableRow,
  Typography,
} from "@mui/material";
import { useAppDispatch } from "../../redux/store";
import { setErrorObj } from "../redux/errorReducer";
import apiServices from "../services/apiServices";
import AdminPageFrame from "../components/AdminPageFrame";
import LoadingModal from "../../components/LoadingModal";
import ContainerPaper from "../components/ContainerPaper";
import { mngStyles } from "../constants/styles";

export default function CategoryList() {
  const [loading, setIsLoading] = useState<boolean>(false);
  const [categories, setCategories] = useState<any[]>([]);

  const dispatch = useAppDispatch();

  const getCategories = async () => {
    try {
      setIsLoading(true);
      const categories = await apiServices.getCategories();
      setCategories(categories.categories);
    } catch (error: any) {
      dispatch(setErrorObj(error))
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    getCategories();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <AdminPageFrame>
      <LoadingModal visible={loading} />

      <ContainerPaper>
        <TableContainer component={Paper}>
          <Table sx={{ minWidth: 650 }} aria-label="caption table">
            <TableHead>
              <TableRow>
                <TableCell colSpan={2}>{T("mng_data_definitions_categories")}</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {categories.map((category: any) => (
                <TableRow key={category.id}>
                  <TableCell component="th" scope="row">
                    <Box display="flex" alignItems="center">
                      <Typography variant="subtitle1" style={mngStyles.titletable}>
                        {category.name}
                      </Typography>
                    </Box>
                  </TableCell>
                  <TableCell align="right">
                    {TF("mng_category_posts_count", category.posts_count)}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </ContainerPaper>
    </AdminPageFrame>
  );
}
